import React from "react";
import { useSelector } from "react-redux";
import Timeline from "./TimeLine";

const GestionesCaso = ({ gestiones }) => {
  const theme = useSelector((state) => state.theme.theme) || "light";

  if (!gestiones || gestiones.length === 0) {
    return (
      <div className="text-center py-5">
        <p style={{ color: theme === "dark" ? "#c3cbe4" : "#C8E6C9" }}>
          No hay gestiones disponibles para este caso
        </p>
      </div>
    );
  }

  return (
    <div>
      <Timeline gestiones={gestiones} />
    </div>
  );
};

export default GestionesCaso;